export const getMetaTitle = (product, language) => {
  if (product && language) {
    const { title } = product;

    if (language === 'ru-RU') {
      return `Купить NFT ${title}`
    } else {
      return `Buy NFT ${title}`;
    }
  }

  return '';
}

export const getMetaDescription = (product, language) => {
  if (product && language) {
    const { title, user } = product;
    const username = user?.username || '';

    if (language === 'ru-RU') {
      return `Marketplace BIT.TEAM - покупка/продажа NFT ${title}. 
        Купить NFT от ${username}, уникальные аукционы и минт новых NFT коллекций ${username}`;
    } else {
      return `Marketplace BIT.TEAM - buy/sell NFT ${title}. 
        Buy NFT from ${username}, unique auctions and mint of ${username}'s new NFT collections`;
    }
  }

  return '';
}